
const CollectionName = "order";

let unsubscribeOrders;
let unsubscribeOrder;


//when canceled from client
export async function deleteOrder({ docId }) {
  return await db.deleteDocument(CollectionName, docId);
}

export async function unsubOrders() {
  if (unsubscribeOrders) await db.removeListener(unsubscribeOrders)
}

export async function unsubOrder() {
  if (unsubscribeOrder) await db.removeListener(unsubscribeOrder)
}

export async function getOrders(code, limit, cb) {
  console.log("get orders");

  unsubOrders();
  
  unsubscribeOrders = await db.listenToCollection(CollectionName, [
    ['where', "businessId", "==", code, "string"],
    ['where', "paid", "==", true, 'boolean'],
    ['orderBy', 'createdAt', 'asc'],
    // ['limit', limit] // There is a bug - not showing new orders when more than 50 closed. Shouldnt it be sorted by desc?
  ], cb)
}

export async function getOrdersByDates(code, from, to, limit) {
  limit = limit || 500;

  console.log("get orders by dates");
  const filters = [
    ["where", "businessId", "==", code, "string"],
    ["where", "open", "==", false, 'boolean'],
    // ["where", "createdAt", ">=", from],
    // ["where", "createdAt", "<=", to],
    ["orderBy", "createdAt", "asc"],
    ["limit", limit],
  ];

  const orders = await db.getCollection(CollectionName, filters);

  return orders.filter(x => {
    let createdAt = new Date(+x.createdAt.seconds * 1000);
    return createdAt > from && createdAt <= to
  });
}

export async function deleteAllOrders() {
  await db.callable("deleteAllOrders");
}

export async function orderReady(order) {
  await db.callable("orderReady", order);
}

export async function cancelAndRefund(orderId, reason) {
  // todo: fix typo after figuring out how to solve cors issue with new function
  await db.callable("cancleOrderAndRefund", { orderId, reason });
}

export async function callUpdateOrderFcm(orderId, token) {
  await db.callable("updateOrderFcmToken", { token, orderId });
}


export async function closeOrderBeforePay(orderId) {
  // todo: fix typo after figuring out how to solve cors issue with new function
  await db.callable("cancleUnpaidOrder", orderId);
}

export async function setOrderAlertOff(orderId, userId) {
  return await db.updateDocument(
    CollectionName,
    orderId,
    {
      alert: {
        seenBy: userId,
        seenAt: db.serverTimestamp(),
        on: false,
      }
    });

}

export async function listenToUserOrders(uid, cb) {
  if (unsubscribeOrder) {
    await db.removeListener(unsubscribeOrder)
  }
  const filters = [
    ['where', 'userId', '==', uid, 'string'],
    ['where', 'open', '==', true, 'boolean'],
  ];
  unsubscribeOrder = await db.listenToCollection(CollectionName, filters, cb);
}

export async function setOrderStatus(orderId, status) {
  let updateObj = { status };
  switch (status) {
    case "closed":
      updateObj.closedAt = db.serverTimestamp();
      updateObj.open = false;
  }
  await db.updateDocument(CollectionName, orderId, updateObj);
}
